module.exports = __webpack_public_path__ + "img/info-filled.7eb744ef.svg";